import {Entity} from "../../core/commons/entity";
import {City} from "./city";
/**
 * Created by Federico on 25/03/2017.
 */
export class Address implements Entity {
    public id: number = null;
    public street: string = '';
    public city: City = null;

    constructor(value: Object = {}) {
        Object.assign(this, value);
        this.city = new City(this.city);
    }

    toString(): string {
        return this.street + ', ' + this.city.name;
    }

}


// WEBPACK FOOTER //
// ./src/app/profile/domain/address.ts